<template>
  <p v-if="href" class="link" :class="{ grey: isGrey }">
    <a :href="href">
      {{ text }}
    </a>
  </p>
  <p v-else class="link" :class="{ grey: isGrey }" @click="onClick">
    {{ text }}
  </p>
</template>

<script>
export default {
  name: "text-link",
  props: {
    href: {
      type: String,
      require: false,
      default: undefined,
    },
    text: {
      type: String,
      require: true,
    },
    isGrey: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  text-align: center;
  margin: 16px 0;
  font-size: 0.9rem;
  color: #5cd5d6;
  a {
    color: #5cd5d6;
    text-decoration: none;
  }
  &.grey {
    color: grey;
    a {
      color: grey;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Text/TextLink.vue